"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = callWithPromise;

var _typeofOrNull = _interopRequireDefault(require("../misc/typeofOrNull"));

var _onCallGlobal = _interopRequireDefault(require("./onCallGlobal"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var functionName = 'callWithPromise';

function callWithPromise(client, callee) {
  if (typeof callee !== 'function') {
    throw new Error("\n        ".concat(functionName, " expected a function as its callee (second argument) but receieved\n        an argument of type ").concat((0, _typeofOrNull["default"])(callee), ". Check\n        that you are passing a valid callee into the call method.\n      "));
  }

  try {
    for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      args[_key - 2] = arguments[_key];
    }

    var result = callee.apply(void 0, [client].concat(args));

    if (result && typeof result.then === 'function') {
      var promise = result;
      var calleeArgs = [].concat(args);
      (0, _onCallGlobal["default"])(client, callee, calleeArgs, promise);
      return result;
    }

    if (result instanceof Error) {
      return Promise.reject(result);
    }

    return Promise.resolve(result);
  } catch (err) {
    return Promise.reject(err);
  }
}